import { createPurchase } from '@api/createPurchase'
import { useMutation } from '@tanstack/react-query'
// import type { CreatePurchasePayload, CreatePurchaseResponse } from '@api/createPurchase'

export const useCreatePurchase = () =>
  // useMutation<CreatePurchaseResponse, Error, CreatePurchasePayload>({
  //   mutationFn: createPurchase,
  // })
  useMutation({
    mutationFn: createPurchase,
  })
